export default {
  mask: '遮罩',
  onlyOneTip: '同个场景内仅支持添加1个遮罩组件。',
  maskComponent: '遮罩组件',
  maskSetting: '遮罩设置',
  isEnable: '组件是否启用',
  enableText: '启用',
  disableText: '禁用',
  addMaskGroup: '新建遮罩组',
  layer: {
    maskGroup: '遮罩组',
    maskedGroup: '被遮罩组',
    maskShapeGroup: '遮罩形状',
    maskShape: '形状',
    followGroup: '跟随元素',
  },
  maskGroup: {
    enableTip: '禁用后，该遮罩组下所有图层的事件将被禁用',
    maskShape: '遮罩形状',
    maskShapeTip: '禁用后，该遮罩形状及跟随元素隐藏，且无遮罩效果。',
    shape: '形状',
    rect: '矩形',
    round: '圆形',
    preview: '预览遮罩效果',
    cancelPreview: '取消预览遮罩效果',
    followElement: '跟随元素',
    followElementTip:
      '设置跟随元素后，需为形状添加拖拽事件，设置完成后，跟随元素将会跟随形状的拖拽位移。',
    addSubGroupDialog: {
      title: '添加分组',
      groupName: '分组名称',
      groupNamePlaceholder: '请输入分组名称',
      groupNameEmptyWarning: '不能为空',
    },
    maskSubGroupCanMaskTip:
      '被遮罩组内的图像，在遮罩形状覆盖范围内的部分会显示，覆盖范围外的部分会隐藏。',
    maskSubGroupCanNotMaskTip: '该分组不会被遮罩',
  },
}
